import { useState, useEffect } from 'react';
import api from '../services/api';
import { useI18n } from '../i18n';

export default function AllTimeView() {
  const { t, locale } = useI18n();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/time/summary/all')
      .then((r) => setData(r.data))
      .finally(() => setLoading(false));
  }, []);

  const formatMins = (mins) => {
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return `${h}h ${m.toString().padStart(2, '0')}m`;
  };

  return (
    <div>
      <h4 className="mb-4"><i className="bi bi-bar-chart-line me-2" />{t('alltime.title')}</h4>
      {loading ? (
        <div className="text-center"><div className="spinner-border" /></div>
      ) : data ? (
        <div className="row g-4">
          <div className="col-md-3 col-6">
            <div className="card text-center h-100">
              <div className="card-body">
                <i className="bi bi-clock-history fs-2 text-primary" />
                <div className="fs-3 fw-bold mt-2">{formatMins(data.total_worked_minutes)}</div>
                <div className="text-muted small">{t('alltime.totalWorked')}</div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="card text-center h-100">
              <div className="card-body">
                <i className="bi bi-calendar-check fs-2 text-success" />
                <div className="fs-3 fw-bold mt-2">{data.total_days}</div>
                <div className="text-muted small">{t('alltime.daysWorked')}</div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="card text-center h-100">
              <div className="card-body">
                <i className="bi bi-calendar-event fs-2 text-info" />
                <div className="fs-3 fw-bold mt-2">
                  {data.first_entry ? new Date(data.first_entry).toLocaleDateString(locale) : '–'}
                </div>
                <div className="text-muted small">{t('alltime.firstEntry')}</div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="card text-center h-100">
              <div className="card-body">
                <i className="bi bi-calendar2-check fs-2 text-warning" />
                <div className="fs-3 fw-bold mt-2">
                  {data.last_entry ? new Date(data.last_entry).toLocaleDateString(locale) : '–'}
                </div>
                <div className="text-muted small">{t('alltime.lastEntry')}</div>
              </div>
            </div>
          </div>
          {data.total_days > 0 && (
            <div className="col-12">
              <div className="card">
                <div className="card-body text-center">
                  <span className="text-muted">{t('alltime.avgPerDay')} </span>
                  <strong className="fs-5">{formatMins(Math.round(data.total_worked_minutes / data.total_days))}</strong>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <p className="text-muted">{t('alltime.noData')}</p>
      )}
    </div>
  );
}
